<script lang="ts">
	interface Props {
		full?: boolean
		children?: import('svelte').Snippet
	}

	let { full = false, children }: Props = $props()
</script>

<div
	class="overflow-hidden rounded-md border border-gray-200 bg-white shadow-md dark:border-none dark:bg-gray-700 {full
		? ''
		: 'p-3'}"
>
	{@render children?.()}
</div>
